import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class PublicBillComparisonVm {
	guidCode?: string;
	email?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'guidCode': new UntypedFormControl(null, [...(validators['guidCode'] ?? []), ...[]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): PublicBillComparisonVmFromFg {
		return new PublicBillComparisonVmFromFg(fg);
	}
}

export class PublicBillComparisonVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get guidCode(): string {
		return this.fg.get('guidCode').value;
	}
	set guidCode(val) {
		this.fg.get('guidCode').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}
}
